import { updatesData } from '@/mocks/homeData';

const tagStyles: Record<string, string> = {
  '实时': 'bg-primary-500/20 text-primary-400',
  '突发': 'bg-primary-500/25 text-primary-300',
  '追踪': 'bg-accent-500/20 text-accent-400',
  '活动': 'bg-secondary-500/20 text-secondary-400',
  '爆料': 'bg-accent-500/15 text-accent-300',
  '讨论': 'bg-secondary-500/15 text-secondary-300',
  '更新': 'bg-secondary-500/12 text-secondary-200',
  '独家': 'bg-primary-500/15 text-primary-300',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-2">最新动态</h2>
            <p className="text-sm text-foreground-500">24小时滚动更新 · 热点快讯不停歇</p>
          </div>
          <span className="hidden sm:inline-flex items-center gap-1.5 text-xs text-foreground-500">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
            实时滚动
          </span>
        </div>
        <div className="relative pl-6 md:pl-8 border-l-2 border-background-200/60">
          {updatesData.map((item, i) => (
            <div key={i} className={`relative pb-6 md:pb-8 ${i === updatesData.length - 1 ? 'pb-0' : ''}`}>
              <div className="absolute -left-[25px] md:-left-[29px] w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100"></div>
              <div className="bg-background-50 rounded-lg p-4 border border-background-200/60 hover:border-primary-500/20 transition-all">
                <div className="flex items-start justify-between gap-3 mb-2">
                  <p className="text-sm text-foreground-300 leading-relaxed">{item.content}</p>
                  <span className={`px-2 py-0.5 text-[10px] font-medium rounded whitespace-nowrap flex-shrink-0 ${tagStyles[item.tag] || 'bg-background-200 text-foreground-500'}`}>{item.tag}</span>
                </div>
                <span className="text-xs text-foreground-600">{item.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}